(() => {
  const SELECTORS = {
    stickyRoot: '[data-sticky-atc]',
    dataScriptPrefix: 'StickyATCData-',
    productForm: 'form[action*="/cart/add"]',
    variantIdInput: 'input[name="id"]',
    qtyInput: 'input[name="quantity"]',
  };

  function parseJSONScript(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent.trim()); }
    catch (e) { return null; }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function formatMoney(cents, moneyFormat) {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';
    const format = moneyFormat || '${{amount}}';
    const placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      const num = (number / 100).toFixed(precision);
      const parts = num.split('.');
      const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const centsPart = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsPart;
    }

    let formatted = '';
    switch (placeholder) {
      case 'amount':
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ',', '.');
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  function findVariantById(data, id) {
    const vid = Number(id);
    if (!vid || !data?.product?.variants?.length) return null;
    return data.product.variants.find(v => Number(v.id) === vid) || null;
  }

  function findProductRoot(data, stickyEl) {
    const root = document.getElementById(data.productInfoRootId);
    if (root) return root;
    return stickyEl.closest('section') || document;
  }

  function findForm(root) {
    return root.querySelector(SELECTORS.productForm) || document.querySelector(SELECTORS.productForm);
  }

  function findMainSubmitButton(form) {
    if (!form) return null;
    return (
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]') ||
      form.querySelector('button[name="add"]') ||
      null
    );
  }

  function findBuyButtonsContainer(form, submitBtn) {
    if (!form || !submitBtn) return null;
    return (
      submitBtn.closest('.buy-buttons-block') ||
      submitBtn.closest('.product-form-buttons') ||
      submitBtn.closest('.buy-buttons') ||
      submitBtn.parentElement ||
      form
    );
  }

  function findVariantInputsRoot(root) {
    return (
      root.querySelector('variant-radios') ||
      root.querySelector('variant-selects') ||
      root.querySelector('.product-form__input') ||
      null
    );
  }

  function findSizeBlock(root) {
    const candidates = [
      ...root.querySelectorAll(
        'fieldset, .product-form__input, variant-radios, variant-selects, .product-form__input--dropdown, .product-form__input--pill'
      )
    ];

    const sizeRegex = /\bsize\b/i;
    for (const el of candidates) {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (sizeRegex.test(text)) return el;
    }

    const labelish = [...root.querySelectorAll('label, legend')];
    for (const l of labelish) {
      const t = (l.textContent || '').trim();
      if (sizeRegex.test(t)) {
        return l.closest('fieldset, .product-form__input, variant-radios, variant-selects') || null;
      }
    }

    return null;
  }

  function isSizeChosen(sizeBlock) {
    if (!sizeBlock) return false;

    const checkedRadio = sizeBlock.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return true;

    const select = sizeBlock.querySelector('select');
    if (select) {
      const v = (select.value || '').trim();
      if (!v) return false;
      if (/select|choose|pick/i.test(select.selectedOptions?.[0]?.textContent || '')) return false;
      return true;
    }

    return false;
  }

  // ✅ FIX: get size label from the actual UI
  function getSelectedSizeLabel(sizeBlock) {
    if (!sizeBlock) return null;

    const checked = sizeBlock.querySelector('input[type="radio"]:checked');
    if (checked) {
      const id = checked.id;
      let labelEl = null;

      if (id) {
        try {
          labelEl = sizeBlock.querySelector(`label[for="${CSS.escape(id)}"]`);
        } catch (e) {
          labelEl = sizeBlock.querySelector(`label[for="${id}"]`);
        }
      }

      if (!labelEl) labelEl = checked.closest('label');

      const labelText = (labelEl ? labelEl.textContent : (checked.value || ''))
        .replace(/\s+/g, ' ')
        .trim();

      if (!labelText) return checked.value || null;

      // If your labels include measurements like: "S 29-32", take the first token.
      // If you use "Large" / "Medium", you can remove the split.
      return labelText.split(' ')[0] || labelText;
    }

    const select = sizeBlock.querySelector('select');
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      const txt = (select.selectedOptions[0].textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) return null;
      if (/select|choose|pick/i.test(txt)) return null;
      return txt;
    }

    return null;
  }

  function focusFirstSizeInput(sizeBlock) {
    if (!sizeBlock) return;
    const focusable =
      sizeBlock.querySelector('input[type="radio"]') ||
      sizeBlock.querySelector('select') ||
      sizeBlock.querySelector('button, [tabindex]:not([tabindex="-1"])');
    if (focusable && typeof focusable.focus === 'function') {
      focusable.focus({ preventScroll: true });
    }
  }

  function highlightTarget(el) {
    if (!el) return;
    el.classList.add('sticky-atc__highlight');
    window.setTimeout(() => el.classList.remove('sticky-atc__highlight'), 950);
  }

  function scrollToTarget(el) {
    if (!el) return;
    el.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }

  function packLabel(qty) {
    return qty === 1 ? '1 PAIR' : `${qty} PAIRS`;
  }

  function setLiveText(stickyEl, text) {
    const live = stickyEl.querySelector('[data-sticky-live]');
    if (live) live.textContent = text || '';
  }

  function setButtonState(btn, { label, disabled }) {
    if (!btn) return;
    btn.textContent = label;
    btn.disabled = !!disabled;
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  // ✅ Read qty from form first (pack-selector controls this)
  function getQtyFromFormOrSticky(form, stickyEl) {
    const formQty = form?.querySelector(SELECTORS.qtyInput);
    const raw = formQty ? Number(formQty.value) : NaN;
    if (Number.isFinite(raw) && raw >= 1) return raw;

    // fallback only if you still have sticky pack radios (safe even if removed)
    const checked = stickyEl.querySelector('input[data-sticky-pack]:checked');
    const qty = checked ? Number(checked.value) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  // ✅ Keep sticky pack radios checked in sync with qty (safe even if radios removed)
  function syncStickyPackRadios(stickyEl, qty) {
    const q = Number(qty);
    if (![1, 2, 3, 5].includes(q)) return;
    const input = stickyEl.querySelector(`input[data-sticky-pack][value="${q}"]`);
    if (input && !input.checked) input.checked = true;
  }

  // ✅ Find your custom pack selector element in the product section (tag starts with PACK-SELECTOR-)
  function findPackSelectorEl(root) {
    const candidates = Array.from(root.querySelectorAll('[data-product]'));
    return candidates.find(el => (el.tagName || '').toUpperCase().startsWith('PACK-SELECTOR-')) || null;
  }

  // Find the pack selector wrapper (the div with data-pack-selector or pack radio inputs)
  function findPackWrap(root) {
    return (
      root.querySelector('[data-pack-selector]')?.closest('[class*="__wrap"]') ||
      root.querySelector('[data-pack-selector]') ||
      null
    );
  }

  // Check if a pack has been selected (any pack radio is checked)
  function isPackChosen(root) {
    const packRadios = root.querySelectorAll('[data-pack-selector] input[type="radio"]');
    if (!packRadios.length) return true; // no pack selector = not needed
    return Array.from(packRadios).some(r => r.checked);
  }

  // ✅ Select pack card by checking its radio inside the custom element
  function syncPackSelectorUI(packSelectorEl, qty) {
    if (!packSelectorEl) return;
    const q = Number(qty);
    if (![1, 2, 3, 5].includes(q)) return;

    const radio = packSelectorEl.querySelector(`input[type="radio"][value="${q}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateUI({ stickyEl, data, variant, sizeChosen, qty, sizeBlock }) {
    const priceEl = stickyEl.querySelector('[data-sticky-price]');
    const sizeLabel = stickyEl.querySelector('[data-sticky-size-label]');
    const cta = stickyEl.querySelector('[data-sticky-cta]');
    const moneyFormat = data.moneyFormat;

    // Price
    if (priceEl) {
      if (variant?.price != null) {
        priceEl.textContent = formatMoney(variant.price, moneyFormat);
      } else {
        priceEl.textContent = '';
      }
    }

    // Size pill — mirrors size selection state
    const hasSizeOption = Number(data.sizeOptionIndex) !== -1;

    let sizeText = 'Select size';
    if (!hasSizeOption) {
      sizeText = 'One size';
    } else {
      const uiLabel = getSelectedSizeLabel(sizeBlock);
      if (uiLabel) {
        sizeText = uiLabel;
      } else if (sizeChosen && variant) {
        const idx = Number(data.sizeOptionIndex);
        const opt = Array.isArray(variant.options) ? variant.options[idx] : null;
        const label = (opt || '').trim();
        sizeText = label || 'Select size';
      }
    }
    if (sizeLabel) sizeLabel.textContent = sizeText;

    // CTA — mirrors the on-page buy button exactly
    // Read the main ATC button text to stay in sync
    const mainForm = document.querySelector('form[action*="/cart/add"]');
    const mainBtn = mainForm && mainForm.querySelector('button[type="submit"], button[name="add"]');
    const mainBtnText = mainBtn ? (mainBtn.querySelector('.add-to-cart-text__content') || mainBtn) : null;
    const mainText = mainBtnText ? mainBtnText.textContent.trim() : '';

    if (!variant) {
      setButtonState(cta, { label: 'SELECT A SIZE', disabled: false });
      setLiveText(stickyEl, 'Select a size to continue.');
      return;
    }

    if (!variant.available) {
      setButtonState(cta, { label: 'SOLD OUT', disabled: true });
      setLiveText(stickyEl, 'Selected variant is sold out.');
      return;
    }

    if (hasSizeOption && !sizeChosen) {
      setButtonState(cta, { label: 'SELECT A SIZE', disabled: false });
      setLiveText(stickyEl, 'Select a size to continue.');
      return;
    }

    // Size selected, variant available — always "ADD TO CART".
    // No "SELECT A PACK" step; sticky bar adds a single pair regardless
    // of the on-page pack selector state.
    setButtonState(cta, { label: 'ADD TO CART', disabled: false });
    setLiveText(stickyEl, 'Ready to add to cart.');
  }

  // Visibility: show once you've scrolled past the main buy buttons, but fade
  // out at the very bottom of the page so the sticky bar doesn't cover the
  // dark-mode toggle / footer controls on mobile.
  const BOTTOM_FADE_THRESHOLD = 180; // px from bottom of document to start fading
  const visibilityState = {
    belowBuyButtons: false,
    nearBottom: false
  };

  function updateStickyVisibility(stickyEl) {
    if (!isMobile()) {
      stickyEl.classList.add('is-hidden');
      return;
    }

    if (visibilityState.belowBuyButtons && !visibilityState.nearBottom) {
      stickyEl.classList.remove('is-hidden');
    } else {
      stickyEl.classList.add('is-hidden');
    }
  }

  function attachBelowBuyButtonsObserver(stickyEl, buyButtonsContainer) {
    if (!buyButtonsContainer || !('IntersectionObserver' in window)) return null;

    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        visibilityState.belowBuyButtons = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateStickyVisibility(stickyEl);
      },
      { root: null, threshold: 0 }
    );

    obs.observe(buyButtonsContainer);
    return obs;
  }

  function attachBottomFadeListener(stickyEl) {
    if (!stickyEl) return;
    let ticking = false;
    function check() {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const docHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight
      );
      const distanceFromBottom = docHeight - (scrollY + viewport);
      const nowNearBottom = distanceFromBottom < BOTTOM_FADE_THRESHOLD;
      if (nowNearBottom !== visibilityState.nearBottom) {
        visibilityState.nearBottom = nowNearBottom;
        updateStickyVisibility(stickyEl);
      }
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  function submitFormWithQty(form, qty, packPropertyValue) {
    if (!form) return;

    let qtyInput = form.querySelector('input[name="quantity"]');
    let createdQty = false;
    let previousQty = null;

    if (qtyInput) {
      previousQty = qtyInput.value;
      qtyInput.value = String(qty);
    } else {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      qtyInput.value = String(qty);
      form.appendChild(qtyInput);
      createdQty = true;
    }

    let propInput = null;
    if (qty > 1) {
      propInput = form.querySelector('input[name="properties[_pack]"]');
      if (!propInput) {
        propInput = document.createElement('input');
        propInput.type = 'hidden';
        propInput.name = 'properties[_pack]';
        propInput.value = String(packPropertyValue || qty);
        form.appendChild(propInput);
      } else {
        propInput.value = String(packPropertyValue || qty);
      }
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      const submitBtn = findMainSubmitButton(form);
      if (submitBtn) submitBtn.click();
      else form.submit();
    }

    window.setTimeout(() => {
      if (qtyInput) {
        if (createdQty) qtyInput.remove();
        else if (previousQty != null) qtyInput.value = previousQty;
      }
    }, 250);
  }

  function initSticky(stickyEl) {
    const sectionId = stickyEl.getAttribute('data-section-id');
    const data = parseJSONScript(`${SELECTORS.dataScriptPrefix}${sectionId}`);
    if (!data) return;

    const root = findProductRoot(data, stickyEl);
    const form = findForm(root);
    if (!form) return;

    const idInput = form.querySelector(SELECTORS.variantIdInput);
    const submitBtn = findMainSubmitButton(form);
    const buyButtonsContainer = findBuyButtonsContainer(form, submitBtn);

    attachBelowBuyButtonsObserver(stickyEl, buyButtonsContainer);
    attachBottomFadeListener(stickyEl);

    const sizeBlock = findSizeBlock(root) || findVariantInputsRoot(root) || form;
    const packSelectorEl = findPackSelectorEl(root);
    const qtyInput = form.querySelector(SELECTORS.qtyInput);

    function computeStateAndRender() {
      const currentVariantId = idInput?.value || data.product.firstAvailableVariantId;
      const variant = findVariantById(data, currentVariantId);

      const hasSizeOption = Number(data.sizeOptionIndex) !== -1;
      let sizeChosen = true;
      if (hasSizeOption) {
        sizeChosen = sizeBlock ? isSizeChosen(sizeBlock) : !!currentVariantId;
      }

      const qty = getQtyFromFormOrSticky(form, stickyEl);

      // safe even if sticky pack radios removed
      syncStickyPackRadios(stickyEl, qty);

      updateUI({ stickyEl, data, variant, sizeChosen, qty, sizeBlock });
      return { variant, sizeChosen, qty };
    }

    computeStateAndRender();

    const changeHandler = () => computeStateAndRender();
    root.addEventListener('change', changeHandler, true);
    root.addEventListener('input', changeHandler, true);
    // Listen for Horizon's actual variant events (not the wrong 'variant:change')
    root.addEventListener('variant:selected', changeHandler);
    root.addEventListener('variant:update', changeHandler);

    if (qtyInput) {
      qtyInput.addEventListener('change', changeHandler);
      qtyInput.addEventListener('input', changeHandler);
    }

    // Watch the main ATC button text for changes (pack selector updates it)
    const mainFormEl = findForm(root);
    const mainBtnEl = mainFormEl && findMainSubmitButton(mainFormEl);
    const mainBtnTextEl = mainBtnEl && (mainBtnEl.querySelector('.add-to-cart-text__content') || mainBtnEl);
    if (mainBtnTextEl) {
      const btnObserver = new MutationObserver(() => {
        // Small delay so the pack selector finishes its DOM updates first
        window.setTimeout(computeStateAndRender, 20);
      });
      btnObserver.observe(mainBtnTextEl, { childList: true, characterData: true, subtree: true });
    }

    // If sticky pack radios still exist, keep sync behavior (harmless if removed)
    stickyEl.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.matches('input[data-sticky-pack]')) {
        const qty = Number(t.value) || 1;

        let formQty = form.querySelector(SELECTORS.qtyInput);
        if (!formQty) {
          formQty = document.createElement('input');
          formQty.type = 'hidden';
          formQty.name = 'quantity';
          form.appendChild(formQty);
        }
        formQty.value = String(qty);
        formQty.dispatchEvent(new Event('input', { bubbles: true }));
        formQty.dispatchEvent(new Event('change', { bubbles: true }));

        syncPackSelectorUI(packSelectorEl, qty);
        computeStateAndRender();
      }
    }, true);

    const cta = stickyEl.querySelector('[data-sticky-cta]');
    const pill = stickyEl.querySelector('[data-sticky-atc-variant]');

    function handleSelectSizeScroll() {
      const block = findSizeBlock(root) || findVariantInputsRoot(root) || form;
      if (!block) return;
      scrollToTarget(block);
      highlightTarget(block);
      window.setTimeout(() => focusFirstSizeInput(block), prefersReducedMotion() ? 0 : 250);
    }

    function handleScrollToPack() {
      const packWrap = findPackWrap(root);
      if (!packWrap) return;
      scrollToTarget(packWrap);
      highlightTarget(packWrap);
    }

    function handleCTA() {
      const { variant, sizeChosen, qty } = computeStateAndRender();
      const hasSizeOption = Number(data.sizeOptionIndex) !== -1;

      // 1) No size chosen → scroll user back up to the size picker
      if (!variant) return handleSelectSizeScroll();
      if (!variant.available) return;
      if (hasSizeOption && !sizeChosen) return handleSelectSizeScroll();

      // 2) Size chosen → add a single pair to cart, regardless of any
      // pack selector state on the page.
      submitFormWithQty(form, 1, 1);
    }

    if (cta) cta.addEventListener('click', handleCTA);
    if (pill) pill.addEventListener('click', handleSelectSizeScroll);

    window.addEventListener('resize', () => {
      if (!isMobile()) stickyEl.classList.add('is-hidden');
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll(SELECTORS.stickyRoot).forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
